export default __webpack_public_path__ + "static/media/MoonWasp.a19ed1ce.svg";